export default __webpack_public_path__ + "static/media/favorite.6b013ba0.svg";